<template>
  <div class="row">
    <div class="col-xxl-12">
      <CompaniesList />
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import CompaniesList from "../../components/Companies/CompaniesList.vue";
import { mapActions } from 'vuex';

export default defineComponent({
  name: "UsersPage",
  components: {
    CompaniesList
  },
  methods: {
    ...mapActions([
      "setUsersList"
    ]),
  },
  mounted() {
    this.setUsersList();
  },
});
</script>